import {useSettingsQuery} from '../../../common/providers/ApiInterface'

export const useOperationalStatuses = () => {
  return useSettingsQuery('upmOperationalStatuses', [], {
    gcTime: 0,
    retry: false,
    staleTime: 0
  })
}

export const QueryKey = 'upmOperationalStatuses'
